import { useEffect, useState } from 'react';
import { http } from '@/lib/api';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function SupportingMen() {
  const [guides, setGuides] = useState([]);
  const [active, setActive] = useState(null);
  useEffect(() => { http.get('/learn/supporting-men').then(r => setGuides(r.data)); }, []);

  return (
    <div className="p-6 space-y-6" data-testid="supporting-men-page">
      <Link to="/app/learn" className="flex items-center gap-2 text-sm text-navy/60"><ArrowLeft size={14}/>Back</Link>
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-gold font-semibold">For loved ones</p>
        <h1 className="font-heading text-3xl mt-2">Supporting the Men You Care About</h1>
        <p className="text-navy/60 mt-2 text-sm">For partners, parents, siblings, friends, mentors, pastors, and coaches.</p>
      </div>

      {active ? (
        <div className="bg-white rounded-3xl p-8 card-soft space-y-4" data-testid="guide-active">
          <button onClick={()=>setActive(null)} className="text-sm text-navy/60">← All guides</button>
          <p className="text-xs uppercase tracking-widest text-navy/50">{active.audience}</p>
          <h2 className="font-heading text-2xl">{active.title}</h2>
          <p className="text-navy/80 leading-relaxed whitespace-pre-wrap">{active.body}</p>
        </div>
      ) : (
        <div className="space-y-3">
          {guides.map(g => (
            <button key={g.id} onClick={()=>setActive(g)} data-testid={`guide-${g.id}`}
              className="w-full text-left bg-white rounded-3xl p-6 card-soft hover:-translate-y-0.5 transition-smooth">
              <p className="text-[10px] uppercase tracking-widest text-navy/50">{g.audience}</p>
              <p className="font-heading text-lg mt-1">{g.title}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
